import React from 'react';
import { POPUP_CONTENT_ID, TPopupContentId } from '@/store/reducers';
import { TermsUpdatedContent } from '@/features/dataConsent/TermsUpdatedModal/TermsUpdatedContent';
import { IPopupContentProps } from './popupContent.types';

export const POPUP_CONTENT_REGISTRY: Record<
  TPopupContentId,
  React.FC<IPopupContentProps>
> = {
  [POPUP_CONTENT_ID.TERMS_UPDATED]: TermsUpdatedContent,
};
